import { render } from "./contentCreatePersonModalMobile.vue?vue&type=template&id=53fc8b0d&scoped=true"
import script from "./contentCreatePersonModalMobile.vue?vue&type=script&lang=js"
export * from "./contentCreatePersonModalMobile.vue?vue&type=script&lang=js"

import "./contentCreatePersonModalMobile.vue?vue&type=style&index=0&id=53fc8b0d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fc8b0d"]])

export default __exports__